import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BatchStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ChangeBatchStatusParams {
  batchId: string;
  status: BatchStatus;
}

export const useChangeBatchStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, status }: ChangeBatchStatusParams) => {
      return request({
        path: `admin/batch-status/${batchId}`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { status },
      });
    },
    onSuccess: () => {
      toast.success('Batch status updated!');
      queryClient.invalidateQueries({ queryKey: ['admin-batches'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating batch status!');
    },
  });
};
